import React from 'react'

const EditUserProfile = () => {
  return (
    <div>EditUserProfile</div>
  )
}

export default EditUserProfile